import { useQuery } from "@tanstack/react-query";
import { useProfileContext } from "context";
import { getAIAssistantInstallation } from "api/bAIAssistantApi";

export function useAIAssistantInstallation() {
  const { userProfile } = useProfileContext();
  return useQuery({
    queryKey: ["ai-assistant", userProfile?.organisation_id, userProfile?.user_id, "installation"],
    queryFn: getAIAssistantInstallation,
    enabled: !!userProfile?.user_id,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
